"use strict";

/**
 * @file
 * R4V tabs.
 */
(function (Drupal) {
  'use strict';

  Drupal.behaviors.tabs = {
    attach: function attach(context, settings) {
      var tabs = context.querySelectorAll('.js-tabs');
      var tabActivate = 0;

      try {
        if (typeof isListMode !== 'undefined') {
          tabActivate = isListMode ? 1 : 0;
        }
      } catch (error) {
        console.error(error);
      }

      if (!tabs.length) {
        return;
      }

      tabs.forEach(function (tab) {
        var tabItems = tab.querySelectorAll('.icon-tabs__item');

        if (!tabItems.length) {
          return false;
        }

        tabItems[tabActivate].isActive = true; // tab item

        tabItems.forEach(function (item) {
          var targetEl = tab.querySelector("#".concat(item.getAttribute('data-target')));

          if (!targetEl) {
            return;
          }

          targetEl.classList.add('d-none');

          if (item.isActive) {
            item.classList.add('is-active');
            targetEl.classList.remove('d-none');
          }

          if (item.onclick) {
            return;
          }

          item.addEventListener('click', function (e) {
            e.preventDefault(); // already active

            if (item.classList.contains('is-active')) {
              return;
            } // disable active element


            var activeEl = tab.querySelector('.is-active');
            var targetActiveEl = tab.querySelector("#".concat(activeEl.getAttribute('data-target')));
            targetActiveEl.classList.add('d-none');
            activeEl.classList.remove('is-active'); // enable click element

            var newTargetEl = tab.querySelector("#".concat(item.getAttribute('data-target')));
            item.classList.add('is-active');
            newTargetEl.classList.remove('d-none');
          });
        });
      });
    }
  };
})(Drupal);